
import router from '../../router';

const current_route = {
    namespaced: true,
    state: () => ({
        currentRoute: '',
    }),
    mutations: {
        setRoute(state, route) {
            state.currentRoute = route;
        },
        reload() {
            router.go();
        }
    },

}


export default current_route;